import React, { Component, useState } from 'react';
import { connect } from 'react-redux';

import CheckedOpbList from './CheckedOpbList';
import ContentsMng from './ContentsMng';
import ContentsAdd from './ContentsAdd';
import OpbPreview from './OpbPreview';
import Confirm from '../Dialog/Confirm';
import { templateMngService, opbcdtService } from '../../services';
import { alertActions } from '../../modules/alert';
import { history } from '../../helpers';
import TemplateMng from './TemplateMng';
import OpbSection from './OpbSection';
import { CancelBtn, NextBtn, PrevBtn, PreviewBtn, PublishBtn } from './OpbStateBtn';
import { Slide, Snackbar, Step, StepLabel, Stepper } from '@material-ui/core';
import PropertiesDialog from './PropertiesDialog';

class ScreenMod extends Component {
    mounted = true;

    constructor(props) {
        super(props);
        if (!props.location.state) history.goBack();
        const { opbInfo, checkedOpbList } = props.location.state;

        this.state = {
            open: false,
            previewOpbInfo: null,
            previewOpen: false,

            checkedOpbList: checkedOpbList,
            selectedOpbInfo: "",
            opbInfo: {
                siteID: opbInfo.siteID,
                coBeginDate: opbInfo.coBeginDate,
                coEndDate: opbInfo.coEndDate,
                opbID: 0,
                opbNo: 0,
                templateID: 0,
                themeID: 0,
                templateStatus: false,
                promotionList: [],
                promotionStatus: false,
                marketingList: [],
                marketingStatus: false,
                bottomList: [],
                bottomStatus: false,
                deleteList: [],
                pubType: "derv", // derv = 예약배포, now = 즉시배포
                groupStatus: true,
                checkedOpbIDs: checkedOpbList && checkedOpbList.length > 0 ? checkedOpbList.map(opb => opb.opbID) : [],
            },
            templateList: [],
            selectedContents: "CT002", // CT002 = 상단, CT003 = 중단, CT004 = 하단

            activeTabId: 1,
            refresh: true,
            text: "",
            snackOpen: false,
            isMobile: false,
        };

        this.getTemplateLists();
    }

    componentDidMount = () => {
        if (this.state.checkedOpbList.length === 1) this.setOpbInfo(this.state.checkedOpbList[0].opbID);
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    };

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile: isMobile });
        }
    }

    // 템플릿 전체목록 호출
    getTemplateLists = () => {
        templateMngService.list()
            .then(response => {
                const defaultTheme = (response.data && response.data[0] && response.data[0].themes) ? response.data[0].themes[0] : { templateID: 0, themeID: 0 };
                this.setState({
                    templateList: response.data,
                    opbInfo: {
                        ...this.state.opbInfo,
                        templateID: this.state.opbInfo.templateID === 0 ? defaultTheme.templateID : this.state.opbInfo.templateID,
                        themeID: this.state.opbInfo.themeID === 0 ? defaultTheme.themeID : this.state.opbInfo.themeID,
                    }
                });
                this.handleSnackOpen(this.state.isMobile ? "그룹 편집 시 기존에 설정된 내용이 초기화 됩니다." : "현장확인 후 테마, 색상, 층입력방식을 선택하세요.");
            })
            .catch(this.handleErrors);
    };

    // 1개의 OPB 화면 편집 시 해당 OPB 정보 호출
    setOpbInfo = (opbID) => {
        let formData = new FormData();
        formData.append("siteID", this.state.opbInfo.siteID);
        formData.append("opbID", opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                this.setState({
                    opbInfo: {
                        ...this.state.opbInfo,
                        ...response.data,
                        groupStatus: false,
                    }
                }, () => { console.log("setOpbInfo 호출"); console.log(this.state); });
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    // 템플릿설정 수정
    setTemplateInfoStatus = (name, templateID, themeID) => {
        if (name === "template") {
            this.setState({
                opbInfo: {
                    ...this.state.opbInfo,
                    templateStatus: true,
                    templateID: parseInt(templateID),
                    themeID: parseInt(themeID),
                },
            }, () => { console.log("template > template 정보 변경"); console.log(this.state.opbInfo); });
            this.handleSnackOpen("영상편집 할 영역을 선택하세요.");
        }
    };

    // 컨텐츠설정 수정
    setContentsStatus = (statusKey, targetKey, value, deleteContentIDs) => {
        let deleteList = (this.state.opbInfo.deleteList ? this.state.opbInfo.deleteList : []);

        (deleteContentIDs && deleteContentIDs.map(contentID => {
            if (contentID !== -1) deleteList = deleteList.concat(contentID);
            return contentID;
        }));

        this.setState({
            opbInfo: {
                ...this.state.opbInfo,
                [statusKey]: true,
                [targetKey]: value,
                deleteList: deleteList,
            },
        }, () => { console.log(statusKey + "정보 변경"); console.log(this.state.opbInfo); });
    };

    // ScreenMod 닫기
    handleClose = () => {
        history.goBack();
    };

    // 미리보기 열기
    handleOpenPreview = () => {
        this.setState({
            previewOpbInfo: this.state.opbInfo,
            previewOpen: true,
        });
    };
    // 미리보기 닫기
    handleClosePreview = () => {
        this.setState({
            previewOpbInfo: null,
            previewOpen: false,
        });
    };



    // 예약배포(derv), 즉시배포(now) 값 변경
    handlePubTypeChange = (value) => {
        this.setState({
            opbInfo: {
                ...this.state.opbInfo,
                pubType: value,
            }
        });
    };

    // activeTabId 이동
    handleActiveTabIdChange = (activeTabId) => {
        if (activeTabId === 0) history.goBack();
        else {
            this.setState({
                activeTabId: activeTabId,
            });
        }

        let text = "그룹 편집 시 기존에 설정된 내용이 초기화 됩니다.";
        if (activeTabId === 2) text = "테마, 색상, 층입력방식을 선택하세요.";
        if (activeTabId === 3) text = "영상편집 할 영역을 선택하세요.";
        if (activeTabId === 4) text = "배포방식을 선택하세요.";

        this.handleSnackOpen(text);
    };

    // 영상편집 타입 변경(상단,중단,하단)
    handleSelectedContents = (value) => {
        this.setState({
            selectedContents: value,
            activeTabId: 5,
        });
        this.handleSnackOpen("영상을 추가/삭제/변경하세요.");
    };

    // 컨텐츠 전체삭제 기능
    handleContentsDel = () => {
        const { selectedContents } = this.state;
        const { promotionList, marketingList, bottomList } = this.state.opbInfo;
        let contents = { prevContentList: "", statusKey: "", targetKey: "" };
        if (selectedContents === "CT002") contents = { prevContentList: promotionList, statusKey: "promotionStatus", targetKey: "promotionList" };
        else if (selectedContents === "CT003") contents = { prevContentList: marketingList, statusKey: "marketingStatus", targetKey: "marketingList" };
        else if (selectedContents === "CT004") contents = { prevContentList: bottomList, statusKey: "bottomStatus", targetKey: "bottomList" };
        const { prevContentList, statusKey, targetKey } = contents;

        const contentList = [];
        const deleteContentIDs = prevContentList.map(board => board.opbcontentID);

        this.setContentsStatus(statusKey, targetKey, contentList, deleteContentIDs);
    };


    // 컨텐츠 추가 기능
    setContentListAdd = (contentTypeCode, addList, addContentType) => {
        const { promotionList, marketingList, bottomList } = this.state.opbInfo;
        let contents = { prevContentList: "", statusKey: "", targetKey: "" };
        if (contentTypeCode === "CT002") contents = { prevContentList: promotionList, statusKey: "promotionStatus", targetKey: "promotionList" };
        else if (contentTypeCode === "CT003") contents = { prevContentList: marketingList, statusKey: "marketingStatus", targetKey: "marketingList" };
        else if (contentTypeCode === "CT004") contents = { prevContentList: bottomList, statusKey: "bottomStatus", targetKey: "bottomList" };
        const { prevContentList, statusKey, targetKey } = contents;

        let contentList = (addContentType === "addSelectContent" ? prevContentList : []);
        let deleteContentIDs = (addContentType === "addOpbContent" ? prevContentList.map(board => board.opbcontentID) : []);

        addList.map(content => contentList = contentList.concat(content));

        this.setContentsStatus(statusKey, targetKey, contentList, deleteContentIDs);
    };


    // 스낵바 열기/닫기
    handleSnackOpen = (text) => {
        this.setState({
            text: text,
            snackOpen: true
        });
    };
    handleSnackClose = () => {
        this.setState({
            snackOpen: false
        });
    };

    // selectedOpbInfo 호출 및 제거
    setSelectedOpbInfo = (opbID) => {
        let formData = new FormData();
        formData.append("siteID", this.state.opbInfo.siteID);
        formData.append("opbID", opbID);
        opbcdtService.selectedOpb(formData)
            .then(response => {
                this.setState({
                    selectedOpbInfo: response.data
                }, () => { console.log("setSelectedOpbInfo 호출"); console.log(this.state); });
            })
            .catch(this.handleErrors);
    };
    selectedOpbInfoRefresh = () => {
        this.setState({
            selectedOpbInfo: ""
        });
    };


    render() {
        const { checkedOpbList, selectedOpbInfo, templateList, opbInfo, selectedContents, isMobile, activeTabId, previewOpbInfo, previewOpen, text, snackOpen } = this.state;
        const { siteID, opbID, opbNo, coBeginDate, coEndDate, promotionList, marketingList, bottomList, pubType } = opbInfo;

        let contents = { contentsTypeCode: "", contentsTypeName: "", contentList: "" };
        if (selectedContents === "CT002") contents = { contentList: promotionList, contentsTypeName: "상단", contentsTypeCode: "CT002" };
        else if (selectedContents === "CT003") contents = { contentList: marketingList, contentsTypeName: "중앙", contentsTypeCode: "CT003" };
        else if (selectedContents === "CT004") contents = { contentList: bottomList, contentsTypeName: "하단", contentsTypeCode: "CT004" };
        const { contentsTypeCode, contentsTypeName, contentList } = contents;

        const steps = ["현장확인", "테마선택", "영상편집", "배포"];

        return (
            <div className={`screenMod`} style={{ flexDirection: isMobile ? "column" : "", backgroundColor: isMobile ? "#ffffff" : "" }}>
                <OpbPreview opbInfo={previewOpbInfo} open={previewOpen} handleClosePreview={this.handleClosePreview} />
                {selectedOpbInfo &&
                    <PropertiesDialog opbInfo={selectedOpbInfo} mode={'opb'} selectedOpbInfoRefresh={this.selectedOpbInfoRefresh} />
                }
                {!isMobile
                    ? // PC버전
                    <>
                        {/* 스낵바(알림창) */}
                        <Snackbar
                            open={snackOpen}
                            message={text}
                            autoHideDuration={3000}
                            anchorOrigin={{ vertical: "top", horizontal: "center" }}
                            TransitionComponent={Slide}
                            style={{ width: "100%", top: "auto", cursor: "pointer" }}
                            ContentProps={{ style: { flexGrow: 1, flexDirection: "column", fontSize: "1.2rem" } }}
                            onClose={this.handleSnackClose}
                            onClick={this.handleSnackClose}
                        />
                        <div className="sm-z1">
                            <div className="sm-z1-1">
                                <div className="checkedOpbList-title">
                                    <div>현장확인</div>
                                </div>
                                <div className="checkedOpbList-image">
                                    <img style={{ height: "100%" }} src="/assets/images/screenMod/ic-elevator.svg" alt="엘리베이터이미지" />
                                </div>
                            </div>
                            <div className="sm-z1-2">
                                <CheckedOpbList opbList={checkedOpbList} setSelectedOpbInfo={this.setSelectedOpbInfo}/>
                            </div>
                        </div>
                        <div className="sm-z2">
                            <div className="sm-z2-1">
                                <div className="sm-z2-11">
                                    <div className="sm-z2-11-1">
                                        <TemplateMng templateID={opbInfo.templateID} themeID={opbInfo.themeID} templateList={templateList} setTemplateInfoStatus={this.setTemplateInfoStatus} />
                                    </div>
                                    <div className="sm-z2-11-2">
                                        <OpbSection opbInfo={opbInfo} handleSelectedContents={this.handleSelectedContents} selectedContents={selectedContents} />
                                    </div>
                                    <div className="sm-z2-11-3">
                                        <div className="contentsmng">
                                            <div className={`contentsmng-title ${selectedContents}`}>
                                                <div>영상 편집 ({contentsTypeName})</div>
                                                <div className="contentsmng-title-button">
                                                    <ContentsDel isMobile={isMobile} handleContentsDel={this.handleContentsDel} />
                                                    <ContentsAdd siteID={siteID} opbID={opbID} opbNo={opbNo}
                                                        contentTypeCode={contentsTypeCode}
                                                        coBeginDate={coBeginDate}
                                                        coEndDate={coEndDate}
                                                        setContentListAdd={this.setContentListAdd}
                                                    />
                                                </div>
                                            </div>
                                            <ContentsMng contentList={contentList}
                                                contentsTypeCode={contentsTypeCode}
                                                coBeginDate={coBeginDate}
                                                coEndDate={coEndDate}
                                                setContentsStatus={this.setContentsStatus}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sm-z2-2">
                                <CancelBtn className="button cancel-button" validation={opbInfo.templateStatus || opbInfo.floorsStatus || opbInfo.promotionStatus || opbInfo.marketingStatus || opbInfo.bottomStatus} isMobile={isMobile} handleClose={this.handleClose} />
                                <PreviewBtn className="button preview-button" handleOpenPreview={this.handleOpenPreview} />
                                <PublishBtn className="button publish-button" opbInfo={opbInfo} userID={this.props.myInfo.userID} isToolTip={!isMobile} handleClose={this.handleClose} PubTypeChange={PubTypeChange} />
                            </div>
                        </div>
                    </>
                    : // 모바일버전
                    <>
                        {/* 스낵바(알림창) */}
                        <Snackbar
                            open={snackOpen}
                            message={text}
                            autoHideDuration={3000}
                            anchorOrigin={{ vertical: "top", horizontal: "center" }}
                            TransitionComponent={Slide}
                            style={{ height: "60px", top: "auto", cursor: "pointer" }}
                            ContentProps={{ style: { flexGrow: 1, flexDirection: "column", fontSize: "1.2rem" } }}
                            onClose={this.handleSnackClose}
                            onClick={this.handleSnackClose}
                        />
                        {(activeTabId === 1 || activeTabId === 2 || activeTabId === 3 || activeTabId === 4) &&
                            <>
                                <div style={{ width: "100%", height: "60px", padding: "10px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundImage: "linear-gradient(135deg, #3e62f9 70%, #ef3fe9)", color: "#ffffff" }}>
                                    <div>화면편집 [{activeTabId}/4]</div>
                                    <CancelBtn className="button cancel-button" validation={opbInfo.templateStatus || opbInfo.floorsStatus || opbInfo.promotionStatus || opbInfo.marketingStatus || opbInfo.bottomStatus} isMobile={isMobile} handleClose={this.handleClose} />
                                </div>
                                <div style={{ width: "100%", height: "100px" }}>
                                    <Stepper style={{ width: "100%", height: "100%", padding: "0px", alignItems: "center", backgroundColor: "#f8f8f8" }}
                                        alternativeLabel
                                        activeStep={activeTabId - 1}
                                    >
                                        {steps.map((label, i) => (
                                            <Step key={label}>
                                                <StepLabel  >
                                                    <div style={{ fontWeight: "bold" }}>{label}</div>
                                                </StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </div>
                                <div style={{ width: "100%", height: "calc(100vh - 240px)", padding: "0px 10px", overflow: "overlay" }}>
                                    {activeTabId === 1 &&
                                        <>
                                            <div style={{ height: "30px", margin: "10px 0px", fontSize: "18px", fontWeight: "bold" }}>현장 확인</div>
                                            <div className="sm-z1-2-M">
                                                <CheckedOpbList opbList={checkedOpbList} setSelectedOpbInfo={this.setSelectedOpbInfo}/>
                                            </div>
                                        </>
                                    }
                                    {activeTabId === 2 &&
                                        <div className="sm-z2-11-1-M">
                                            <TemplateMng templateID={opbInfo.templateID} themeID={opbInfo.themeID} templateList={templateList} isMobile={isMobile} setTemplateInfoStatus={this.setTemplateInfoStatus} />
                                        </div>
                                    }
                                    {activeTabId === 3 &&
                                        <>
                                            <div style={{ height: "30px", margin: "10px 0px", fontSize: "18px", fontWeight: "bold" }}>영상편집</div>
                                            <div className="sm-z2-11-2-M">
                                                <OpbSection opbInfo={opbInfo} isMobile={isMobile} handleSelectedContents={this.handleSelectedContents} selectedContents={selectedContents} />
                                            </div>
                                        </>
                                    }
                                    {activeTabId === 4 &&
                                        <>
                                            <div style={{ height: "30px", margin: "10px 0px", fontSize: "18px", fontWeight: "bold" }}>배포</div>
                                            <PubTypeChange pubType={pubType} handlePubTypeChange={this.handlePubTypeChange} />
                                        </>
                                    }
                                </div>
                                <div style={{ height: "80px", display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                                    {(activeTabId === 1 || activeTabId === 2 || activeTabId === 3) &&
                                        <>
                                            <PrevBtn className="button prev-button" activeTabId={activeTabId} handleActiveTabIdChange={this.handleActiveTabIdChange} disabled={activeTabId === 1} />
                                            <NextBtn className="button next-button" activeTabId={activeTabId} handleActiveTabIdChange={this.handleActiveTabIdChange} disabled={activeTabId === 1} />
                                        </>
                                    }
                                    {activeTabId === 4 &&
                                        <>
                                            <PrevBtn className="button prev-button" activeTabId={activeTabId} handleActiveTabIdChange={this.handleActiveTabIdChange} disabled={activeTabId === 1} />
                                            <PublishBtn className="button publish-button-M" opbInfo={opbInfo} userID={this.props.myInfo.userID} isToolTip={!isMobile} handleClose={this.handleClose} PubTypeChange={PubTypeChange} />
                                        </>
                                    }
                                </div>
                            </>
                        }
                        {activeTabId === 5 &&
                            <>
                                <div className="" style={{ width: "100%", height: "60px", padding: "10px 20px", display: "flex", alignItems: "center", backgroundColor: "#3e62f9", color: "#ffffff" }}>
                                    <img style={{ width: "15px", height: "15px", marginRight: "15px" }} src="/assets/images/screenMod/m-btn-back.svg" alt="뒤로" />
                                    <div>영상 편집 ({contentsTypeName})</div>
                                </div>
                                <div style={{ width: "100%", height: "calc(100vh - 140px)" }}>
                                    <div className="sm-z2-11-3-M">
                                        <ContentsMng contentList={contentList}
                                            contentsTypeCode={contentsTypeCode}
                                            coBeginDate={coBeginDate}
                                            coEndDate={coEndDate}
                                            setContentsStatus={this.setContentsStatus}
                                        />
                                    </div>
                                </div>
                                <div style={{ height: "80px", display: "flex", justifyContent: "space-around", alignItems: "center", backgroundColor: "#888b92" }}>
                                    <ContentsAdd siteID={siteID} opbID={opbID} opbNo={opbNo} isMobile={isMobile}
                                        contentTypeCode={contentsTypeCode}
                                        coBeginDate={coBeginDate}
                                        coEndDate={coEndDate}
                                        setContentListAdd={this.setContentListAdd}
                                    />
                                    <NextBtn className="button next-button" activeTabId={activeTabId} handleActiveTabIdChange={this.handleActiveTabIdChange} disabled={activeTabId === 1} />
                                </div>
                            </>
                        }
                    </>
                }
            </div>
        );
    }
}


// 배포 선택
const PubTypeChange = ({ pubType, handlePubTypeChange }) => {

    return (
        <div className="pubType-change">
            <div className={`pubType-change-button${pubType === "derv" ? " active" : ""}`} onClick={() => { handlePubTypeChange("derv"); }}>
                <img style={{ width: "30px", height: "30px", margin: "10px" }} src="/assets/images/screenMod/ic-reservation.svg" alt="" />
                <div>예약배포</div>
            </div>
            <div className={`pubType-change-button${pubType !== "derv" ? " active" : ""}`} onClick={() => { handlePubTypeChange("now"); }}>
                <img style={{ width: "30px", height: "30px", margin: "10px" }} src="/assets/images/screenMod/ic-now.svg" alt="" />
                <div>즉시배포</div>
            </div>
        </div>
    );
};

// 전체삭제 버튼
export const ContentsDel = ({ isMobile, handleContentsDel }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => {
        setOpen(!open);
    };

    return (
        <>
            <button className={`button${isMobile ? " w100-button" : " w120-button"}`} onClick={handleOpen}>전체삭제</button>
            {open &&
                <Confirm message={"전체 삭제하시겠습니까?\n삭제하신 영상은 [추가]버튼을 클릭하면\n불러올 수 있습니다."} kind={"del"} handleFormSubmit={handleContentsDel} handleClose={handleOpen} />
            }
        </>
    );
};


function mapState(state) {
    const { alert, userinfo } = state;
    const myInfo = userinfo.item;
    return { alert, myInfo };
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(ScreenMod);